import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import { langDashCodesDictionary } from "../../../../../constants";

const Table = ({ data }) => {
	const { t, i18n } = useTranslation();
	const lang = i18n.language;

	const formatDate = (date) => {
		const nDate = new Date(date);
		return nDate
			.toLocaleDateString(langDashCodesDictionary[lang] || "pl-PL", {
				month: "numeric",
				year: "numeric",
			})
			.replaceAll(".", "-");
	};

	return (
		<Box
			sx={{
				display: "flex",
				width: "100%",
				justifyContent: "space-between",
			}}
		>
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					rowGap: "10px",
					flex: "1 1 160px",
					"& > div": {
						padding: "10px 20px",
						flex: "1 1 20%",
					},
				}}
			>
				<Box></Box>
				<Box sx={{ background: "#f5f5f5" }}>{t("entered_1")}</Box>
				<Box sx={{ background: "#f5f5f5", color: "#AE78D6" }}>
					{t("sold_label")}
				</Box>
				<Box sx={{ background: "#f5f5f5", color: "#00B050" }}>
					{t("margin_label")} (€)
				</Box>
				<Box sx={{ background: "#f5f5f5", color: "#F07C00" }}>
					{t("income")} (€)
				</Box>
			</Box>

			{data.map((values, index) => {
				return (
					<Box
						key={`sa-prev-months-table-row-${index}`}
						sx={{
							display: "flex",
							flexDirection: "column",
							rowGap: "10px",
							flex: "1 1 calc((100% - 160px)/13)",
							"& > div": {
								flex: "1 1 20%",
								padding: "10px 0",
								textAlign: "center",
							},
						}}
					>
						<Box>{formatDate(values.date)}</Box>
						<Box sx={{ background: "#f5f5f5" }}>{values.entered}</Box>
						<Box sx={{ background: "#f5f5f5", color: "#AE78D6" }}>
							{values.sold}
						</Box>
						<Box sx={{ background: "#f5f5f5", color: "#00B050" }}>
							{values.margin}
						</Box>
						<Box sx={{ background: "#f5f5f5", color: "#F07C00" }}>
							{values.income}
						</Box>
					</Box>
				);
			})}
		</Box>
	);
};

export default Table;
